import request from '@/utils/request'
import { xlsDownload } from '@/api/view/hip/common/commonXls'

export function epms9010DetailList(param) {
    let data = param
    return request({
        url: `/deliveryControl/epms9010Detail/epms9010DetailList`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function epms9010fabSetStatus(param) {
    let data = param
    return request({
        url: `/deliveryControl/epms9010Detail/epms9010fabSetStatus`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function epms9010DelFabDte(param) {
    let data = param
    return request({
        url: `/deliveryControl/epms9010Detail/epms9010DelFabDte`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}